export default {"src":"/_next/static/media/ARMK.4dda8bfb.svg","height":18,"width":18};